import React from 'react';
import { Table } from '@indigo-ag/component-module';
import { columnDefinition, rowDefinition, ConditionalsValidationRow } from './ConditionalsTable.config';
import styled from 'styled-components';
import i18next from 'i18next';

const TableWrapper = styled.div`
  max-height: 15rem;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  padding: 1rem 1rem 1rem 0.25rem;
`;

interface ConditionalsTableProps {
  data: ConditionalsValidationRow[];
}

const ConditionalsTable: React.FC<ConditionalsTableProps> = ({ data }) => {
  return (
    <TableWrapper>
      <Table
        label={i18next.t('conditionalValidations-table-label')}
        columnDefinition={columnDefinition}
        rowDefinition={rowDefinition}
        data={data}
        tableStyle="inline"
      />
    </TableWrapper>
  );
};

export default ConditionalsTable;
